import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { useNavigate } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "#edf2f8",
    boxSizing: "border-box",
    padding: "1px 20px 8px 3px",
    width: "100%",
    [theme.breakpoints.down("xs")]: {
      padding: "12px",
    },
  },
  bar: {
    alignItems: "center",
    backgroundColor: "#0d2740",
    boxSizing: "border-box",
    display: "flex",
    gap: 12,
    minHeight: 42,
    padding: "7px 16px",
    width: "100%",
    [theme.breakpoints.down("xs")]: {
      gap: 10,
      padding: "7px 10px",
    },
  },
  backButton: {
    alignItems: "center",
    backgroundColor: "#d8aa2f",
    border: 0,
    borderRadius: 4,
    color: "#071a2c",
    cursor: "pointer",
    display: "inline-flex",
    flexShrink: 0,
    fontFamily: "'DM Sans', sans-serif",
    fontSize: 12,
    fontWeight: 700,
    gap: 4,
    height: 27,
    justifyContent: "center",
    lineHeight: 1,
    padding: "0 11px",
    transition: "background-color 160ms ease, box-shadow 160ms ease",
    "&:hover": {
      backgroundColor: "#e5b83c",
    },
    "&:focus-visible": {
      boxShadow: "0 0 0 3px rgba(255, 255, 255, 0.7)",
      outline: 0,
    },
  },
  backIcon: {
    fontSize: 14,
  },
  titleGroup: {
    alignItems: "center",
    display: "flex",
    gap: 6,
    minWidth: 0,
  },
  
  title: {
    color: "#b9c4cf",
    fontFamily: "'DM Sans', sans-serif",
    fontSize: 12,
    fontWeight: 700,
    lineHeight: 1.3,
    margin: 0,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
}));

const HeaderProcessus = ({ title = "" , icon = null }) => {
  const classes = useStyles();
  const navigate = useNavigate();

  const handleBack = () => {
    navigate("/smq_nc/dashboard");
  };

  return (
    <header className={classes.root}>
      <div className={classes.bar}>
        <button
          aria-label="Retour au tableau de bord des non-conformités"
          className={classes.backButton}
          onClick={handleBack}
          type="button"
        >
          <ArrowBackIcon className={classes.backIcon} aria-hidden="true" />
          Retour NC
        </button>

        <div className={classes.titleGroup}>
          {icon}
          <h1 className={classes.title}>{title}</h1>
        </div>
      </div>
    </header>
  );
};

export default HeaderProcessus;
